import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import * as productApis from "../utilities/apis/product"

const HomeProducts = () => {
  const navigate = useNavigate()
  const [products, setProducts] = useState([])

  const handleView = (slug) => {
    navigate(`/product/${slug}`)
  }

  const getProducts = async () => {
    try {
      const response = await productApis.getHomeProducts()
      if (!response.status) throw new Error(response.message)

      setProducts(response.products)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getProducts()
  }, [])

  if (!products.length) return null

  return (
    <section id="products" className="py-3 py-sm-4 py-lg-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3 mb-sm-4 mb-lg-5">
          <h1 className="fw-bold m-0">Products</h1>
          <Link to="/products">Explore All Products</Link>
        </div>

        <div className="row g-3 g-xl-2">
          {products.map((product) => {
            let src = "/upload.png"
            if (product.thumbnail) src = product.thumbnail
            // if (product.thumbnail_url) src = product.thumbnail_url

            return (
              <div key={product.id.toString()} className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                <div className="card shadow-none text-dark p-1">
                  <img src={src} className="card-img-top img-fluid deal-image" alt={product.title} />
                  <div className="card-body p-1 d-flex flex-column gap-2">
                    <p className="fw-bold m-0 text-truncate">{product.title}</p>
                    <p className="text-theme fw-bold m-0">Rs. {product.price.toFixed(2)}</p>
                    <button className="btn btn-sm btn-outline-theme w-100" onClick={() => handleView(product.slug)}>View</button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeProducts